import {Component, OnInit, ViewChild} from '@angular/core';
import {App, Content, LoadingController, NavController, NavParams} from 'ionic-angular';
import {StorageService} from "../../providers/storage";
import {SocialService} from "../../providers/social-service";
import {TwitterLogin} from "../twitter-login/twitter-login";
import * as moment from 'moment';
//import {timeInterval} from "rxjs/operator/timeInterval";

@Component({
  selector: 'page-tweets',
  templateUrl: 'tweets.html',
})
export class Tweets implements OnInit {
  @ViewChild(Content) content: Content;
  socialEnabled = false;
  tweets = [];
  tweetsStorage = [];
  maxStatusId = 0;
  sinceDate = moment();
  toDate = moment().add(1, 'days');
  allSources = true;
  allKeys = true;
  searchExpr = '';
  watcher;
  loading;
  showSearchField = false;
  showIndex = 0;
  perPage = 10;
  today = new Date();
  minimumDate = moment().subtract(7, 'days').toDate();
  selectedDate = new Date();
  keys = {};

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private storageService: StorageService,
              private socialService: SocialService,
              public app: App,
              private loadingCtrl: LoadingController) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad Tweets');
    this.maxStatusId = 0;
    this.showIndex = 0;
    if (parseInt(this.storageService.get('socialUserId')) === 0 && this.navParams.get('type') !== 'followings' && this.navParams.get('type') !== 'keywords') {
      let nav = this.app.getRootNav();
      nav.setRoot(TwitterLogin);
    }
  }

  ngOnInit() {
    if (this.navParams.get('type') == 'followings') {
      this.allSources = true;
      this.allKeys = false;
      this.loadTweets();
      if (typeof this.watcher !== 'undefined') {
        clearInterval(this.watcher);
      }
    } else {
      this.socialService.getKeywords().subscribe(
        (data) => {
          for (let k of data) {
            this.keys[k.id] = {
              name: k.tag,
              color: '#' + k.color
            }

          }
          // console.log(this.keys)
        },
        (err) => {
        },
        () => {
          this.socialService.getSharedKeywords().subscribe(
            (data) => {
              for (let k of data) {
                this.keys[k.id] = {
                  name: k.tag,
                  color: '#' + k.color
                }

              }
              // console.log(this.keys)
            },
            (err) => console.log(err),
            () => {
              if (typeof this.navParams.get('type') !== 'undefined') {
                if (this.navParams.get('type') == 'followings') {
                  this.allSources = true;
                  this.allKeys = false;
                }
                if (this.navParams.get('type') == 'keywords') {
                  this.allSources = false;
                  this.allKeys = true;

                }
              }
              this.loadTweets();
              if (typeof this.watcher !== 'undefined') {
                clearInterval(this.watcher);
              }
              // watch for twitter updates
            }
          )
        }
      );
    }


  }

  loadTweets() {
    this.maxStatusId = 0;
    this.showIndex = 0;
    this.loading = this.loadingCtrl.create({
      content: 'Attendere...'
      // dismissOnPageChange: true
    });
    this.loading.present();

    this.socialService.status({
      sinceDate: this.sinceDate.format('YYYYMMDD'),
      toDate: this.toDate.format('YYYYMMDD'),
      allSources: this.allSources,
      allKeys: this.allKeys,
      sinceId: this.maxStatusId,
      searchExpr: this.searchExpr
    }).subscribe(
      (data) => {
        this.tweetsStorage = data.statuses;
        while (this.tweets.length > 0) {
          this.tweets.pop();
        }
        this.maxStatusId = data.maxStatusId;
        this.showIndex = 0;
      },
      (err) => {
        // console.log(err);
      },
      () => {
        this.doInfinite(null);
        if (typeof this.watcher === 'undefined') {
          this.watcher = setInterval(
            () => {
              this.loadMoreTweets();
            }, 15000)
        }
        if (typeof this.loading !== 'undefined') {
          this.loading.dismiss();
        }
      }
    )
  }

  loadMoreTweets() {
    if (this.maxStatusId === 0 || this.showIndex === 0) {
      return;
    }
    this.socialService.status({
      sinceDate: this.sinceDate.format('YYYYMMDD'),
      toDate: this.toDate.format('YYYYMMDD'),
      allSources: this.allSources,
      allKeys: this.allKeys,
      sinceId: this.maxStatusId,
      searchExpr: this.searchExpr
    }).subscribe(
      (data) => {
        for (let t of data.statuses.reverse()) {
          // this.tweetsStorage.unshift(t);
          this.tweets.unshift(t);
          // this.showIndex += 1;
        }
        this.maxStatusId = data.maxStatusId;
      },
      (err) => {
        // console.log(err);
      }
    )
  }


  setDate(event) {
    // console.log(event);
    this.sinceDate = moment(event);
    this.toDate = moment(event).add(1, 'days');
    // console.log(this.sinceDate.format('YYYYMMDD'))
    // console.log(this.toDate.format('YYYYMMDD'))
    this.loadTweets();
  }

  onInput(event) {
    // this.maxStatusId = 0;
    // this.showIndex = 0;
    this.loadTweets();
  }

  onCancel(event) {
    this.onInput(event);
  }

  toggleSearch() {
    this.showSearchField = !this.showSearchField;
    if (!this.showSearchField) {
      this.searchExpr = '';
      this.onInput(null);

    }
    this.content.resize();
  }

  doInfinite(infiniteScroll) {
    // console.log('doInfinite');
    // console.log(this.showIndex);
    for (let t of this.tweetsStorage.slice(this.showIndex, this.showIndex + this.perPage)) {
      this.tweets.push(t);
    }
    if (this.showIndex + this.perPage >= this.tweetsStorage.length - 1) {
      this.showIndex = this.tweetsStorage.length - 1;
    } else {
      this.showIndex += 40;
    }
    if (infiniteScroll !== null) {
      infiniteScroll.complete();
    }

  }

  stringAsDate(dateStr) {
    return new Date(dateStr.replace(/-/g, "/"));
  }
}



// WEBPACK FOOTER //
// ./src/pages/tweets/tweets.ts